import { TENANTS } from './constants';
import { getCookie, getTenantName, getUrlParam } from './helpers';
import { requestAccessTokenFromMessageAssist } from './messageassist';
import { InitLoaderValues } from './types';

export const getHealthSystemAccessToken = async (
    initLoaderValues: InitLoaderValues | null
): Promise<string | null> => {
    if (
        getUrlParam('token') === 'message' &&
        initLoaderValues &&
        initLoaderValues.token
    ) {
        return Promise.resolve(initLoaderValues.token);
    }

    if (getUrlParam('token') === 'global') {
        return Promise.resolve(
            (window as any).MOBILE_HEALTH_SYSTEM_JWT || null
        );
    }

    try {
        const cookie = getCookie('health_system_token');

        if (cookie) {
            return cookie;
        }

        if (getTenantName() === TENANTS.MESSAGE_ASSIST) {
            return await requestAccessTokenFromMessageAssist();
        }
    } catch {
        return null;
    }

    return Promise.resolve(null);
};
